import React from "react";
import { useIsDarkMode } from "../lib/utils";
import Button1Widget from "./widget/button-1";
import { getMainWidgetComponent } from "./main-widget-registry";
import Title1Widget from "./widget/title-1";
import AutomationTitle1Widget from "./widget/automation-title1";
import * as Mui from "@mui/material";
import * as ReactLib from "react";

// Main widget component for dashboard cards
const MainWidget = React.memo(
  ({
    widget,
    onValueUpdate,
    onStateUpdate,
    onTriggerEvent,
    onTitleClick,
    onTitleHold,
    titleBindWidget,
  }) => {
    let DataWidgetComponent;

    const actualMode = useIsDarkMode();
    const isDynamic = !!widget.componentCode;

    // Create minimal theme object for dynamic components (backward compatibility)
    const minimalTheme = { mode: actualMode };

    switch (widget.skin) {
      case "default.title":
      case "default.title1":
        return (
          <Title1Widget
            widget={widget}
            onTitleClick={onTitleClick}
            onTitleHold={onTitleHold}
            bindWidget={titleBindWidget}
          />
        );
      case "default.automationtitle":
        return (
          <AutomationTitle1Widget
            widget={widget}
            onStateUpdate={onStateUpdate}
            onTitleClick={onTitleClick}
            onTitleHold={onTitleHold}
          />
        );
      case "default.button":
        return <Button1Widget widget={widget} onValueUpdate={onTriggerEvent} />;
      default:
        DataWidgetComponent = getMainWidgetComponent(
          widget.skin,
          widget.componentCode
        );
        if (DataWidgetComponent) {
          if (isDynamic) {
            return (
              <DataWidgetComponent
                widget={widget}
                onValueUpdate={onValueUpdate}
                onTriggerEvent={onTriggerEvent}
                theme={minimalTheme}
                Mui={Mui}
                React={ReactLib}
              />
            );
          } else {
            return (
              <DataWidgetComponent
                widget={widget}
                onValueUpdate={onValueUpdate}
                pattern={widget.pattern}
              />
            );
          }
        } else {
          console.debug("Unknown widget type: ", widget.skin);
          return null;
        }
    }
  },
  (prevProps, nextProps) => {
    return (
      prevProps.widget === nextProps.widget &&
      prevProps.titleBindWidget === nextProps.titleBindWidget
    );
  }
);

MainWidget.displayName = "MainWidget";

export default MainWidget;
